import { TextInput } from '@/components/Form/TextInput'
import { SettingsFieldStack } from '@/components/Settings/SettingsFieldStack'
import { useNameManagement } from '@/hooks/useNameManagement'
import { useAuth } from '@/loaders/Auth'
import { useCallback, useRef } from 'react'

import type { ChangeEvent } from 'react'

import { PhoneNumberField } from './PhoneNumberField'

export function ProfileSection() {
	const { email } = useAuth()
	const { tempName, setTempName, nameSuccess, nameLoading, nameError, handleNameUpdate, memberName } =
		useNameManagement()

	// Debounce timer ref
	const debounceTimerRef = useRef<NodeJS.Timeout | null>(null)

	const handleNameChange = useCallback(
		(e: ChangeEvent<HTMLInputElement>) => {
			const newValue = e.target.value
			setTempName(newValue)

			// Clear existing timer
			if (debounceTimerRef.current) {
				clearTimeout(debounceTimerRef.current)
			}

			// Only debounce if value has changed from original
			if (newValue.trim() !== memberName.trim()) {
				debounceTimerRef.current = setTimeout(() => {
					handleNameUpdate(newValue)
				}, 1000)
			}
		},
		[setTempName, memberName, handleNameUpdate]
	)

	return (
		<SettingsFieldStack>
			{/* Name field */}
			<TextInput
				id="name"
				label="Name"
				value={tempName}
				onChange={handleNameChange}
				placeholder="Enter your full name"
				showSuccess={nameSuccess}
				showLoading={nameLoading}
				error={nameError}
			/>

			{/* Email and Phone row */}
			<div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 items-start">
				{/* Email */}
				<TextInput
					id="email"
					label="Email"
					value={email || ''}
					disabled
					helperText="Email cannot be changed"
				/>

				{/* Phone */}
				<PhoneNumberField />
			</div>
		</SettingsFieldStack>
	)
}


